import React from "react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ADMIN_PANEL, BTN_OUTLINE } from "../../config/brand";

export function AdminDetailField({ label, children, className = "" }) {
  const empty = children == null || children === "";
  return (
    <div className={`min-w-0 ${className}`}>
      <dt className="text-[11px] uppercase tracking-[0.06em] text-slate-400">{label}</dt>
      <dd className="text-slate-800 mt-0.5 break-words whitespace-pre-wrap">{empty ? "—" : children}</dd>
    </div>
  );
}

export function AdminDetailSection({ title, children, cols = 2 }) {
  return (
    <section>
      {title ? (
        <h3 className="text-xs font-medium uppercase tracking-[0.08em] text-slate-500 mb-3">{title}</h3>
      ) : null}
      <dl className={cols === 1 ? "space-y-3" : "grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 text-sm"}>
        {children}
      </dl>
    </section>
  );
}

export default function AdminDetailDialog({
  open,
  onOpenChange,
  title,
  children,
  footer,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`${ADMIN_PANEL} text-slate-900 max-w-lg max-h-[85vh] overflow-y-auto`}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-6 py-1">{children}</div>
        <DialogFooter>
          {footer}
          <Button type="button" variant="outline" className={BTN_OUTLINE} onClick={() => onOpenChange(false)}>
            Fermer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
